import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Avatar,
} from "@mui/material";
import { Email, Phone, CalendarMonth, AccessTime } from "@mui/icons-material";
import SideBar from "../Component/SideBar";
import { fetchUserProfile } from "../Api/profileApi";

const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await fetchUserProfile();
        setProfile(data);
      } catch (err) {
        console.error("Error loading profile:", err);
      } finally {
        setLoading(false);
      }
    };
    loadProfile();
  }, []);

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleString(); // returns date and time (e.g. "7/10/2025, 3:33:45 PM")
  };

  const formatDateOnly = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString(); // returns only date
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex" }}>
        <SideBar />
        <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
          <Typography>Loading...</Typography>
        </Box>
      </Box>
    );
  }

  if (!profile) {
    return (
      <Box sx={{ display: "flex" }}>
        <SideBar />
        <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
          <Typography color="error">No profile data available</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <SideBar />
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Paper
              elevation={3}
              sx={{ padding: 4, borderRadius: 3, backgroundColor: "#f5f5f5" }}
            >
              <Box textAlign="center" mb={3}>
                <Avatar
                  sx={{
                    bgcolor: "#1976d2",
                    width: 80,
                    height: 80,
                    margin: "0 auto",
                    fontSize: 32,
                  }}
                >
                  {profile.firstName?.[0] ?? "?"}
                </Avatar>
                <Typography variant="h5" fontWeight="bold" mt={2}>
                  {profile.firstName} {profile.lastName}
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <InfoItem
                  icon={<Email />}
                  label="Email"
                  value={profile.email}
                />
                <InfoItem
                  icon={<Phone />}
                  label="Phone Number"
                  value={`+${profile.countryCode} ${profile.phoneNumber}`}
                />
                <InfoItem
                  icon={<CalendarMonth />}
                  label="Date of Birth"
                  value={formatDateOnly(profile.dateOfBirth)}
                />
                <InfoItem
                  icon={<AccessTime />}
                  label="Account Created"
                  value={formatDateTime(profile.createdAt)}
                />
                {/* <InfoItem
                  icon={<AccessTime />}
                  label="Last Updated"
                  value={formatDateTime(profile.updatedAt)}
                /> */}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const InfoItem = ({ icon, label, value }) => (
  <Grid item xs={12} sm={6}>
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 2,
        backgroundColor: "#fff",
        borderRadius: 2,
      }}
    >
      {icon}
      <Box>
        <Typography fontWeight="bold" variant="body2">
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {value}
        </Typography>
      </Box>
    </Paper>
  </Grid>
);

export default ProfilePage;
